<ng-container
  *ngIf="
      (isStoryMode$ | ngrxPush) ||
      (isPhotoMode$ | ngrxPush) ||
      (isGoProMode$ | ngrxPush)
    "
>
  <div class="camera-container">
    <div
      class="native-gesture-edge"
      (pointerdown)="onNativePointerStart($event)"
      (pointerup)="onNativePointerEnd($event)"
      (touchstart)="onNativeTouchStart($event)"
      (touchend)="onNativeTouchEnd($event)"
    ></div>
    <div class="camera-header justify-content-end flex lg:py-2 px-2"
         (pointerdown)="onNativePointerStart($event)"
         (pointerup)="onNativePointerEnd($event)"
         (touchstart)="onNativeTouchStart($event)"
         (touchend)="onNativeTouchEnd($event)">
      <!--        <mat-icon-->
      <!--          *ngIf="isFlashAvailable$ | ngrxPush"-->
      <!--          class="flash-camera-button"-->
      <!--          [ngClass]="customOrientation$ | ngrxPush"-->
      <!--          (click)="enableTorch()"-->
      <!--        >-->
      <!--          {{ (isFlashOn$ | ngrxPush) ? 'flash_on' : 'flash_off' }}-->
      <!--        </mat-icon>-->

      <!--        <mat-icon-->
      <!--          class="camera-quality-button"-->
      <!--          [ngClass]="customOrientation$ | ngrxPush"-->
      <!--          [svgIcon]="'capture-rebrand-camera-' + (cameraQuality$ | ngrxPush)"-->
      <!--          (click)="toggleCameraQuality()"-->
      <!--        >-->
      <!--        </mat-icon>-->

      <!--        <div-->
      <!--          class="select-from-go-pro-camera-button"-->
      <!--          [ngClass]="customOrientation$ | ngrxPush"-->
      <!--          *ngIf="lastConnectedGoProDevice$ | ngrxPush"-->
      <!--          (click)="captureFromGoPro()"-->
      <!--        >-->
      <!--          GoPro-->
      <!--&lt;!&ndash;          <mat-icon> featured_video </mat-icon>&ndash;&gt;-->
      <!--        </div>-->

      <!--        <mat-icon-->
      <!--          class="close-camera-button"-->
      <!--          [ngClass]="customOrientation$ | ngrxPush"-->
      <!--          (click)="leaveCustomCamera()"-->
      <!--          data-tutorial="highlightCustomCameraCloseButton"-->
      <!--          [title]="t('userGuide.cameraUsageGuide')"-->
      <!--          [text]="-->
      <!--            t('userGuide.afterTakingPhotosOrRecordingVideosCloseAndGoBackHome')-->
      <!--          "-->
      <!--        >-->
      <!--          close-->
      <!--        </mat-icon>-->
      <button pButton pRipple [icon]="'pi pi-sm pi-times'" [ngClass]="{
            'p-button-xs p-button-plain p-button-rounded p-button-text m-0 p-button-icon-only': true
            }"
              (click)="leaveCustomCamera()"
      ></button>
<!--      <app-end-cap-->
<!--        [icon]="'pi pi-sm pi-times'"-->
<!--        [pointerClass]="{-->
<!--            'p-button-xs p-button-plain p-button-rounded p-button-outlined m-0 p-button-icon-only': true-->
<!--            }"-->
<!--        (onClickTrigger)="leaveCustomCamera()"-->
<!--      >-->
<!--      </app-end-cap>-->
    </div>
    <div
      id="camera-preview"
      class="camera-preview"
      [class.camera-preview--native]="isNative"
      (click)="focus($event)"
      (swipeleft)="onSwipeLeft($event)"
      (swiperight)="onSwipeRight($event)"
      (pinchstart)="handlePinchStart($event)"
      (pinchin)="handlePinchIn($event)"
      (pinchout)="handlePinchOut($event)"
    >
<!--      <div-->
<!--        *ngIf="isNative && !cameraPreviewReady"-->
<!--        class="camera-startup-mask"-->
<!--      ></div>-->
      <div
        *ngIf="!isNative"
        id="native-gesture-capture"
        class="native-gesture-capture"
        (pointerdown)="onNativePointerStart($event)"
        (pointerup)="onNativePointerEnd($event)"
        (touchstart)="onNativeTouchStart($event)"
        (touchend)="onNativeTouchEnd($event)"
      ></div>
    </div>

    <div
      class="camera-footer"
      (swipeleft)="onSwipeLeft($event)"
      (swiperight)="onSwipeRight($event)"
      (pointerdown)="onNativePointerStart($event)"
      (pointerup)="onNativePointerEnd($event)"
      (touchstart)="onNativeTouchStart($event)"
      (touchend)="onNativeTouchEnd($event)"
    >
      <div
        class="footer-camera-modes"
        [ngClass]="selectedModeCSSClass$ | ngrxPush"
      >
        <div
          class="camera-mode-item"
          [ngClass]="{ selected: isStoryMode$ | ngrxPush }"
          (click)="selectMode('story')"
        >
          SHORT
        </div>
        <div
          class="camera-mode-item"
          [ngClass]="{ selected: isPhotoMode$ | ngrxPush }"
          (click)="selectMode('photo')"
        >
          PHOTO
        </div>
        <div class="camera-mode-item">
          <!-- Temporary disable/hide GO PRO mode
            But we need this element for proper positioning -->
        </div>
      </div>
      <div class="footer-camera-buttons">
        <!--          <mat-icon class="temporarily-hidden" id="gallery-icon">-->
        <!--            video_collection-->
        <!--          </mat-icon>-->

        <button
          pButton
          pRipple
          class="p-button p-button-lg p-button-rounded p-button-plain p-button-text p-button-icon-only camera-action-button"
          type="button"
          (click)="flipCamera()"
        >
          <span class="material-icons material-symbols-outlined">
flip_camera_ios
</span>
<!--          <i class="pi pi-refresh"></i>-->
        </button>

        <circle-progress
          (click)="onPress()"
          ngxLongPress2
          [maxTime]="maxRecordTimeInMilliseconds"
          [percent]="(curRecordTimeInPercent$ | ngrxPush) ?? 0"
          [outerStrokeColor]="
              (curRecordTimeInPercent$ | ngrxPush) === 0
                ? 'transparent'
                : '#E32323'
            "
          [radius]="38"
          [backgroundPadding]="-6"
          [outerStrokeWidth]="4"
          [space]="3"
          [innerStrokeWidth]="2"
          [backgroundStrokeWidth]="6"
          [outerStrokeLinecap]="'round'"
          [backgroundStroke]="'#ffffff'"
          [innerStrokeColor]="'#000000'"
          [backgroundColor]="
              (isPhotoMode$ | ngrxPush) ? '#ffffff' : '#E32323'
            "
          [showTitle]="false"
          [showUnits]="false"
          [showSubtitle]="false"
          [animation]="false"
        ></circle-progress>

        <button
          pButton
          pRipple
          class="p-button p-button-lg p-button-rounded p-button-plain p-button-text p-button-icon-only camera-action-button"
          type="button"
          [disabled]="!(isFlashAvailable$ | ngrxPush)"
          (click)="toggleFlash()"
        >
          <span class="material-icons material-symbols-outlined">
          {{(isFlashOn$ | ngrxPush) ? 'flash_off' : 'flash_on'}}
          </span>
<!--          <i class="pi" [ngClass]="(isFlashOn$ | ngrxPush) ? 'pi-bolt' : 'pi-ban'"></i>-->
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="(mode$ | ngrxPush) === 'pre-publish'">
  <app-pre-publish-mode
    [curCaptureFilePath]="curCaptureFilePath"
    [curCaptureMimeType]="curCaptureMimeType"
    [curCaptureSrc]="curCaptureSrc"
    (confirm)="confirmCurrentCapture()"
    (discard)="discardCurrentCapture()"
  ></app-pre-publish-mode>
</ng-container>
